module.exports = __webpack_public_path__ + "img/open-package.19a72fcb.png";